var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGamesRewards = function SvgIconGamesRewards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 3.5a5.5 5.5 0 0 1 5.5 5.5v9A1.75 1.75 0 0 1 21 19.75H3a1.75 1.75 0 0 1-1.741-1.577L1.25 18V9a5.5 5.5 0 0 1 5.5-5.5zm-14 14.25h2.5V11.5h-2.5zm15 0h2.5V11.5h-2.5zm-10.5 0h8.5V11.5H14.5v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-2H7.75zm3.75-5.25h1V10h-1zM5.75 5.646A3.5 3.5 0 0 0 3.25 9v.5h2.5zm2 3.854H9.5V9l.005-.103A1 1 0 0 1 10.5 8h3l.102.005A1 1 0 0 1 14.5 9v.5h1.75v-4h-8.5zm10.5 0h2.5V9a3.5 3.5 0 0 0-2.5-3.354z",
    clipRule: "evenodd"
  })));
};
export default SvgIconGamesRewards;